import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bg-h-primary-500 px-4"
}
const _hoisted_2 = { class: "w-full py-16 sm:py-24 container mx-auto" }
const _hoisted_3 = { class: "flex flex-wrap items-center justify-center gap-10" }
const _hoisted_4 = { class: "text-white text-[15px] w-fit text-center flex justify-center" }
const _hoisted_5 = { class: "flex justify-center flex-wrap gap-5 lg:justify-end items-center w-fit" }
const _hoisted_6 = {
  key: 0,
  class: "flex flex-wrap items-center sm:gap-8 gap-2 justify-center"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "flex w-full justify-center items-center bg-h-primary-700" }
const _hoisted_9 = { class: "text-white py-10 text-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Logo = _resolveComponent("Logo")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.$route.path !== '/')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_Logo, { class: "grayscale invert brightness-0" }),
              _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("labels.generic", {
              pt: "Plataforma de educação adaptativa, com uso de inteligência artificial.",
              en: "Adaptive education platform, using artificial intelligence, in which students are trained, according to their availability and learning conditions.",
            })), 1),
              _createElementVNode("div", _hoisted_5, [
                (_ctx.partners?.length !== 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partners, (img, index) => {
                        return (_openBlock(), _createElementBlock("img", {
                          key: index,
                          src: _ctx.getFileUrl(img),
                          class: "w-fit sm:h-8 h-5",
                          loading: "lazy"
                        }, null, 8, _hoisted_7))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("p", _hoisted_9, " © " + _toDisplayString(_ctx.todayYear) + ". " + _toDisplayString(_ctx.$t("labels.generic", {
          pt: "Todos os direitos reservados.",
          en: "All rights reserved.",
        })), 1)
    ])
  ], 64))
}